// extracted by mini-css-extract-plugin
module.exports = {"rotateimg":"form_rotateimg__1DFqy","rotatelogo":"form_rotatelogo__-tJY5","navLink":"form_navLink__2kcfx"};